var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { styled } from 'styled-components';
export var Grid = styled.div.withConfig({ displayName: "Grid", componentId: "sc-6ayv5n" })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: grid;\n  grid-auto-rows: 56px;\n  grid-template-columns: 1fr 40px 1fr 1fr minmax(300px, 1fr);\n"], ["\n  display: grid;\n  grid-auto-rows: 56px;\n  grid-template-columns: 1fr 40px 1fr 1fr minmax(300px, 1fr);\n"])));
var templateObject_1;
